<template>
    <v-card
        flat
        :style="{ 'border-radius': '10px' }"
        outlined
        class="ma-0 pa-0"
    >
        <v-col cols="12" class="font-weight-bold mx-0 mt-2">
            <v-row class="d-flex flex-wrap px-3 align-center">
                <p class="my-0" :style="{ 'font-weight': 'bold !important' }">
                    {{ request.reference }} - {{ request.name }}
                </p>
            </v-row>
            <v-row class="d-flex px-3 align-center mt-3">
                <p class="my-0" style="font-weight: normal">
                    Client:
                    {{ request.clientName }}
                </p>
            </v-row>
            <v-row class="d-flex px-3 align-center mt-3">
                <p class="my-0" style="font-weight: normal">
                    Price:
                    {{ formatCurrency(request.currency, +request.price) }}
                </p>
            </v-row>
            <v-row class="d-flex px-3 align-center mt-3 mb-0">
                <p class="my-0" style="font-weight: normal">
                    Billed:
                    {{
                        request.totalInvoiced
                            ? formatInvoiced(request)
                            : ' 0 (0%)'
                    }}
                </p>
                <v-spacer></v-spacer>
                <v-btn
                    small
                    icon
                    color="primary"
                    class="ml-1 my-0"
                    @click="openProject(request)"
                >
                    <v-icon>
                        mdi-eye
                    </v-icon>
                </v-btn>
            </v-row>
        </v-col>
        <!-- project  -->
        <v-dialog
            :retain-focus="false"
            v-model="viewProject"
            fullscreen
            ref="dialogQuotesBySection"
        >
            <v-card class="fill-height" v-if="viewProject">
                <v-card-title class="ml-n4">
                    <v-btn icon @click="backToProjects">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    {{ selectedProject.name }}
                </v-card-title>
                <v-card-text
                    class="px-0"
                    :style="{ height: `${this.heightPopUp}px` }"
                >
                    <router-view />
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'

export default {
    name: 'ProjectsUserCard',
    props: {
        request: {
            type: Object,
            default: () => ({}),
        },
        users: Array,
        clients: Array,
    },
    data: () => ({
        loding: false,
        originalRequest: {},
        selectedRequest: {},
        createForm: false,
        projectId: null,
        openForm: false,
        constDueDate: {},
        viewProject: false,
        selectedProject: [],
        heightPopUp: 0,
        genericProject: false,
    }),
    updated() {
        this.onResize()
    },
    methods: {
        backToProjects() {
            this.dialogQuote = false
            this.viewProject = false
            this.$router
                .push({
                    name: 'project-managers',
                })
                .catch(error => error && null)
        },
        async openProject(project) {
            if (!this.loading) {
                this.viewProject = true
                this.selectedProject = _.cloneDeep(project)

                if (this.selectedProject.generic == true) {
                    this.$router.push({
                        name: 'projects-generic',
                        params: {
                            id: project.id,
                            project,
                            clients: this.clients,
                            users: this.users,
                            redirection: true,
                        },
                    })
                } else {
                    this.$router.push({
                        name: 'projects',
                        params: {
                            id: project.id,
                            project,
                            clients: this.clients,
                            users: this.users,
                            redirection: true,
                        },
                    })
                }
            }
        },
        onResize() {
            this.height = window.innerHeight - 112
            this.heightPopUp = window.innerHeight - 62
        },
        formatCurrency(currency, value) {
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 0,
            }).format(value)
        },
        openAssignBuyer() {
            this.$emit('openAssignBuyer', this.request.id)
        },
        formatDate(seconds) {
            return moment.unix(seconds).format('MMM DD')
        },
        openRequest() {
            this.constDueDate = this.request.dueDate
            this.projectId = this.request.project.id
            this.request.dueDate = moment
                .unix(this.request.dueDate.seconds)
                .format('YYYY-MM-DD')
            this.openForm = true
        },
        formatInvoiced(item) {
            const totalAmount = item.totalInvoiced
            const percentage = (totalAmount / item.price) * 100
            const formattedInvoiced = new Intl.NumberFormat('de-DE', {
                maximumFractionDigits: 0,
            }).format(totalAmount)
            return `${formattedInvoiced} (${percentage.toFixed(0)}%)`
        },
        closeRequest() {
            this.request.dueDate = this.constDueDate
            this.constDueDate = {}
        },
    },
}
</script>

<style></style>
